import React, { useEffect, useRef, useState } from 'react';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import httpClient from '../../../../services/http';
import { APIUtils } from '../../../../utils/apiutils';
import Swal from 'sweetalert2';
import { Button, TextField, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { CUSTOM_EVENTS, USER_ROLES } from '../../../../utils/constants';
import SendIcon from '@mui/icons-material/Send';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const ChatInput = () => {
    dayjs.extend(utc);
    const userInfo = useSelector(state => state.auth.user);
    const { appointmentDetails } = useAppointmentDetailsContext();
    const [chatText, setChatText] = useState('');
    const chatInputRef = useRef();

    const isChatAllowed = () => {
        const apptDate = dayjs(appointmentDetails.apptdatetime);
        const differenceInHours = apptDate.diff(dayjs.utc(new Date()), 'hour'); // apptDate - now
        if (differenceInHours < 0) {
            return false;
        }
        if (differenceInHours > 72) {
            return false;
        }

        return true;
    };

    const saveAppointmentChat = async (message) => {
        if (!message) return;

        const getIds = () => {
            const userRole = userInfo?.role || USER_ROLES.PATIENT;
            if (userRole === USER_ROLES.PATIENT) {
                return {
                    userId: userInfo.userId,
                    doctorId: appointmentDetails.doctorId,
                };
            }
            return {
                userId: appointmentDetails.userId,
                doctorId: userInfo.userId,
            };
        };

        const addChat = (payload) => {
            const chat = {...payload, tempPic: userInfo.profilePic};
            document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.ADD_TEMP_CHAT_MSG, {detail: chat}));
            setChatText('');
        };

        try {
            const payload = {
                message,
                ...getIds(),
                apptId: appointmentDetails.id,
                senderId: userInfo.userId,
            };
            addChat(payload);
            const res = await httpClient.post(APIUtils.getAPIEndpoint('myappointment-save-chat'), payload).then(res => res.data);
            if (res.status === 'success') {
                console.log({res});
            }
            // else {
            //     setDepartments([]);
            // }
        } catch (error) {
            console.error('Error saving appointment chat:', error);
            if (error?.cause?.response?.data?.message) {
                Swal.fire('Sorry!', error.cause.response.data.message, 'error');
                // setLoading(false);
                return;
            }
            Swal.fire('Something Went Wrong!', '', 'error');
        }
    };

    const handleChatInput = (e) => {
        setChatText(e.target.value);
    };
    const handleChatSubmit = (e) => {
        e.preventDefault();
        if (!isChatAllowed()) { return; }

        const form = e.target; // Get the form element
        const formData = new FormData(form); // Create a FormData object

        // Access the values
        const message = formData.get('message');

        console.log('Message:', message);
        document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.SCROLL_CHAT_WINDOW));
        saveAppointmentChat(message);
    };

    useEffect(() => {
        chatInputRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
        });
    }, []);

    const chatDisabledMsg = !isChatAllowed() && (
        <Typography variant="subtitle2" gutterBottom textAlign="center">
            Chat is disabled after 72 hours of Appointment Date
        </Typography>
    );

    return (
        <>
            {chatDisabledMsg}
            <form ref={chatInputRef} onSubmit={handleChatSubmit} className='chat-input-form'>
                <TextField className='text_input' variant="outlined" value={chatText} onChange={handleChatInput} name='message' autoFocus={true} placeholder='Message' disabled={!isChatAllowed()} />
                <Button variant="contained" className='send-btn' type='submit' disabled={!isChatAllowed()}><SendIcon /></Button>
            </form>
        </>
    );
};

export default ChatInput;